var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "settings_svg__a",
    d: "M23.478 9.391c.288 0 .522.234.522.522v4.174a.522.522 0 01-.522.522h-2.144c-.5 0-.949.302-1.142.77-.204.492-.101 1.023.253 1.376l1.516 1.517a.521.521 0 010 .737l-2.951 2.952a.522.522 0 01-.738 0l-1.517-1.516a1.235 1.235 0 00-1.352-.262c-.492.203-.794.65-.794 1.15v2.145a.522.522 0 01-.522.522H9.913a.522.522 0 01-.522-.522v-2.144c0-.5-.302-.948-.77-1.142a1.243 1.243 0 00-1.376.253L5.728 21.96a.522.522 0 01-.738 0l-2.95-2.952a.521.521 0 010-.737l1.516-1.517c.353-.353.456-.884.261-1.352-.202-.492-.65-.794-1.15-.794H.521A.522.522 0 010 14.087V9.913c0-.288.234-.522.522-.522h2.144c.5 0 .949-.302 1.142-.77.204-.492.101-1.023-.253-1.376L2.04 5.728a.521.521 0 010-.737l2.95-2.952a.522.522 0 01.738 0l1.517 1.516c.353.354.884.456 1.352.262.492-.203.794-.65.794-1.15V.521c0-.289.234-.522.522-.522h4.174c.288 0 .522.233.522.522v2.144c0 .5.302.948.77 1.142.492.204 1.022.101 1.376-.253l1.517-1.516a.522.522 0 01.738 0l2.95 2.952a.521.521 0 010 .737l-1.516 1.517a1.235 1.235 0 00-.261 1.352c.202.492.65.794 1.15.794h2.145zM12 15.652a3.652 3.652 0 100-7.304 3.652 3.652 0 000 7.304z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "settings_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#settings_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#616161",
    mask: "url(#settings_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgSettings;